module.exports = __webpack_public_path__ + "img/9.625d9dfd.jpeg";